import { render, staticRenderFns } from "./netIncome.vue?vue&type=template&id=6ca25cb9&scoped=true"
import script from "./netIncome.vue?vue&type=script&lang=ts"
export * from "./netIncome.vue?vue&type=script&lang=ts"
import style0 from "./netIncome.vue?vue&type=style&index=0&id=6ca25cb9&prod&lang=less&scoped=true"
import style1 from "./netIncome.vue?vue&type=style&index=1&id=6ca25cb9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca25cb9",
  null
  
)

export default component.exports